var exports = {
  "kL": "x127c5a35--558bcc--container",
  "Vs": "x127c5a35--558bcc--tile",
  "qV": "x127c5a35--558bcc--skeleton",
  "$d": "x127c5a35--558bcc--link-area",
  "zC": "x127c5a35--558bcc--images",
  "kZ": "x127c5a35--558bcc--image-wrapper",
  "Qq": "x127c5a35--558bcc--text",
};

module.exports = exports;
